export const TEST_IDS = {
  nav: {
    root: "nav-root",
    brand: "nav-brand",
    linkAbout: "nav-link-about",
    linkApproach: "nav-link-approach",
    linkContent: "nav-link-content",
    linkLearning: "nav-link-learning",
    linkContact: "nav-link-contact",
    linkNewsletter: "nav-link-newsletter",
    linkPolicy: "nav-link-policy",
    cta: "nav-cta-book",
    socialLinkedin: "nav-social-linkedin",
    socialYoutube: "nav-social-youtube",
    socialInstagram: "nav-social-instagram",
  },
  hero: {
    section: "hero-section",
    headline: "hero-headline",
    sub: "hero-subheadline",
    identity: "hero-identity",
    ctaPrimary: "hero-cta-book",
    ctaSecondary: "hero-cta-newsletter",
    image: "hero-image",
  },
  problem: { section: "problem-section" },
  pillars: { section: "pillars-section" },
  credibility: { section: "credibility-section" },
  about: { section: "about-section", headshot: "about-headshot" },
  newsletter: {
    section: "newsletter-section",
    inline: "newsletter-inline",
    footer: "newsletter-footer",
    form: "newsletter-form",
    firstName: "newsletter-first-name",
    lastName: "newsletter-last-name",
    email: "newsletter-email",
    submit: "newsletter-submit",
    success: "newsletter-success",
  },
  policy: {
    section: "policy-section",
    form: "policy-form",
    firstName: "policy-first-name",
    lastName: "policy-last-name",
    email: "policy-email",
    phone: "policy-phone",
    note: "policy-note",
    file: "policy-file",
    submit: "policy-submit",
    success: "policy-success",
  },
  book: { section: "book-section", calendly: "book-calendly", cta: "book-cta" },
  learning: {
    section: "learning-section",
    cardYoutube: "learning-card-youtube",
    cardLinkedin: "learning-card-linkedin",
    cardCall: "learning-card-call",
  },
  footer: {
    section: "footer-section",
    linkedin: "footer-linkedin",
    youtube: "footer-youtube",
    instagram: "footer-instagram",
    email: "footer-email",
    calendly: "footer-calendly",
  },
};
